<template>
  <div class="macarons-graph--multiple-counter">
    <div v-for="(d, i) in data" :key="i" class="macarons-graph--multiple-counter--counter" >
      <counter
        :data="d.value"
        :alwaysRound="alwaysRound"
        :color="color"
        :background-color="backgroundColor"
        :formatter="Array.isArray(formatters) ? formatters[i] : formatters" />
      <div v-if="!hideLabel" class="title" >
        {{ d.label }}
      </div>
    </div>
  </div>
</template>

<script>
import Counter from './Counter'

export default {
  props: {
    data: {
      required: true,
      type: Array
    },
    formatters: {
      type: [Function, Array],
      required: false
    },
    alwaysRound: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Counter
  }
}
</script>

<style scoped>
.macarons-graph--multiple-counter {
    display: inline-block;
    max-height: 100%;
    overflow: hidden;
}
.macarons-graph--multiple-counter:after {
    content: '';
    display: block;
    clear: both;
}
.macarons-graph--multiple-counter--counter {
    width: 140px;
    float: left;
}
.macarons-graph--multiple-counter--counter:last-child:after {
    content: '';
    display: block;
    clear: both;
}
.title {
    margin: 5px 0;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/MultipleCounter.vue